import { DEFAULT_CONTAINER_WIDTH, DEFAULT_SPACING } from './constants';
var getBreakpointForScreenWidth = function (breakpoints, screenWidth) {
    return breakpoints
        .slice()
        .reverse()
        .find(function (point) { return screenWidth >= point.maxWidth; }) || breakpoints[0];
};
// read cookie with the screen width to get the expected column sizes
export var getSliderConfiguration = function (_a) {
    var breakpoints = _a.breakpoints, _b = _a.containerWidth, containerWidth = _b === void 0 ? DEFAULT_CONTAINER_WIDTH : _b, screenWidth = _a.screenWidth, dontScale = _a.dontScale;
    var elementSpacing = DEFAULT_SPACING;
    var _c = getBreakpointForScreenWidth(breakpoints, screenWidth), elementWidth = _c.elementWidth, elementHeight = _c.elementHeight;
    if (dontScale) {
        return {
            elementWidth: elementWidth,
            elementHeight: elementHeight,
        };
    }
    var ratio = elementHeight ? elementWidth / elementHeight : 0;
    // We try to place X elements per row such that width of elements is as close
    // to targetWidth as possible, but not greater
    var elementsPerRow = Math.max(1, Math.floor((containerWidth + elementSpacing) / (elementWidth + elementSpacing)));
    var adjustedElementWidth = (containerWidth + elementSpacing) / elementsPerRow - elementSpacing;
    var adjustedElementHeight = adjustedElementWidth / ratio;
    return {
        elementWidth: adjustedElementWidth,
        elementHeight: adjustedElementHeight,
    };
};
//# sourceMappingURL=helpers.js.map